module.exports = __webpack_public_path__ + "static/media/iCARE_logo.0a7fd42d.png";